<template>
  <div class="container">
    <div class="theme">
        <span>ニックネーム</span>
    </div>
    <div class="title">
        <el-input placeholder="Please input" v-model="UserName"></el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "regist-user-component",
  props: ["title"],
  data() {
    return {
      UserName: "Nick Drake"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  display: flex;
  border: 2px solid #666;
  align-items: stretch;
}
.theme {
  border-right: 1px solid #666;
  width: 120px;
  display: flex;
  justify-content: center; /* 子要素をflexboxにより中央に配置する */
  align-items: center; /* 子要素をflexboxにより中央に配置する */
  & > span {
    display: table-cell;
    font-weight: 600;
  }
}
.title {
  padding: 20px;
  font-size: 1.5em;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistUser.vue